"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARTIST_API_URLS = void 0;
var ARTIST_API_URLS;
(function (ARTIST_API_URLS) {
    ARTIST_API_URLS["ARTIST_CREATE"] = "/v2/artist/create";
    ARTIST_API_URLS["ARTIST_UPDATE_AVATAR"] = "/v2/artist/change-avatar/:id";
    ARTIST_API_URLS["ARTIST_DELETE_AVATAR"] = "/v2/artist/remove-avatar";
    ARTIST_API_URLS["ARTISTS_FETCH"] = "/v2/artist/get-all";
    ARTIST_API_URLS["ARTISTS_FETCH_ONE"] = "/v2/artist/get-info";
    ARTIST_API_URLS["ARTISTS_FETCH_MY"] = "/v2/artist/get-mine";
    ARTIST_API_URLS["ARTIST_UPDATE"] = "/v2/artist/update";
    ARTIST_API_URLS["ARTIST_COUNTRIES"] = "/v2/artist/get-countries";
    ARTIST_API_URLS["ARTIST_DELETE"] = "/v2/artist/delete";
    ARTIST_API_URLS["ARTIST_REMOVE_FROM_UNIVERSE"] = "/v2/artist/remove-from-universe";
    ARTIST_API_URLS["ARTIST_ADD_TO_UNIVERSE"] = "/v2/artist/add-to-universe";
    ARTIST_API_URLS["ARTIST_GET_BY_UNIVERSE"] = "/v2/artist/get-by-universe";
    ARTIST_API_URLS["ARTIST_FETCH_HIGHLIGHTS"] = "/v2/artist/highlights";
    ARTIST_API_URLS["ARTIST_SEARCH"] = "/v2/artist/search";
    ARTIST_API_URLS["ARTIST_GET_BY_FILTER"] = "/v2/artist/get-by-filter";
    ARTIST_API_URLS["CREATOR_REMOVE_BANNER"] = "/v2/artist/remove-banner";
})(ARTIST_API_URLS = exports.ARTIST_API_URLS || (exports.ARTIST_API_URLS = {}));
